const cartData = [
    {
        image: 'assets/images/product/img-1.png',
        name: 'Full sleeve T-shirt',
        color: 'Blue',
        price: '$ 240',
        quantity: 2,
        total: '$ 480'
    },
    {
        image: 'assets/images/product/img-2.png',
        name: 'Half sleeve T-shirt',
        color: 'Red',
        price: '$ 225',
        quantity: 1,
        total: '$ 225'
    },
    {
        image: 'assets/images/product/img-3.png',
        name: 'Hoodie (Green)',
        color: 'Black',
        price: '$ 275',
        quantity: 2,
        total: '$ 550'
    },
    {
        image: 'assets/images/product/img-4.png',
        name: 'Hoodie (Gray)',
        color: 'Gray',
        price: '$ 275',
        quantity: 1,
        total: '$ 275'
    }
];

export { cartData };
